import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { getUserPackage } from "../constants";

const PaymentConfirmation = ({ token }) => {
  const navigate = useNavigate();

  useEffect(() => {
    getUserPackage(token);
  }, []);
  return (
    <div className="flex flex-col w-full h-full justify-between items-start bg-white text-black p-8 gap-10">
      <ToastContainer />
      <div className="flex flex-col w-full gap-5 h-full">
        <div className="text-[32px] font-bold">Payment Status</div>
        <div className="flex flex-col gap-5 w-full justify-center items-center h-full border rounded-lg">
          <svg
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M58.7366 3.19419C53.6908 -1.06473 46.3093 -1.06473 41.2635 3.19419L36.6681 7.07287C34.5235 8.88302 31.8695 9.9824 29.073 10.2189L23.081 10.7256C16.5015 11.282 11.282 16.5015 10.7256 23.081L10.2189 29.073C9.9824 31.8695 8.88302 34.5235 7.07287 36.6682L3.19419 41.2635C-1.06473 46.3093 -1.06473 53.6908 3.19419 58.7366L7.07287 63.3319C8.88302 65.4765 9.9824 68.1307 10.2189 70.927L10.7256 76.9193C11.282 83.4988 16.5015 88.7184 23.081 89.2744L29.073 89.781C31.8695 90.018 34.5235 91.1172 36.6682 92.9275L41.2635 96.8061C46.3093 101.065 53.6908 101.065 58.7366 96.8061L63.3319 92.9275C65.4765 91.1172 68.1307 90.018 70.927 89.781L76.9193 89.2744C83.4988 88.7184 88.7184 83.4988 89.2744 76.9193L89.781 70.927C90.018 68.1307 91.1172 65.4765 92.9275 63.3319L96.8061 58.7366C101.065 53.6908 101.065 46.3093 96.8061 41.2635L92.9275 36.6681C91.1172 34.5235 90.018 31.8695 89.781 29.073L89.2744 23.081C88.7184 16.5015 83.4988 11.282 76.9193 10.7256L70.927 10.2189C68.1307 9.9824 65.4765 8.88302 63.3319 7.07287L58.7366 3.19419ZM74.6302 40.7653C77.0108 38.385 77.0108 34.5257 74.6302 32.1454C72.2504 29.765 68.3908 29.765 66.0102 32.1454L43.2305 54.9253L33.9955 45.6904C31.6152 43.31 27.7559 43.31 25.3755 45.6904C22.9951 48.0707 22.9951 51.93 25.3755 54.3103L38.9205 67.855C41.3008 70.2356 45.1601 70.2356 47.5405 67.855L74.6302 40.7653Z"
              fill="#FF6500"
            />
          </svg>

          <div>Payment Successfull</div>
          <div className="text-[12px]">
            Upgrade Complete! Premium features unlocked
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-between items-center w-full">
        <div
          className="flex text-center w-[200px] py-2 border border-primary text-primary items-center justify-center rounded-md shadow-lg cursor-pointer"
          onClick={() => navigate("/")}
        >
          Home
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmation;
